import React, { useState } from "react";
import Sidebar from "../display/sidebar";
import PDFViewer from "../display/PDFViewer";

const GR = () => {
  // Define folder structure with PDFs
  const pdfStructure = [
    {
      name: "Latest",
      children: [
      
        {
          name: "D.A. Rate Jan 25",
          url: "https://drive.google.com/file/d/1adaVk4JB0ukYgscBdEykN8BxSzB32Xts/view?usp=sharing/view"
        },
      ]
    },
    // {
    //   name: "Goverment Resolutions",
    //   children: [
       
    //     {
    //       name: "Pay Commission",
    //       children: [
    //         {
    //           name: "Pay Commission 1978",
    //           url: "https://drive.google.com/file/d/1tutYi-w0rNQWw006spkWMkxKuK25r8YO/view"
    //         },
    //         {
    //           name: "Pay Commission 1988",
    //           url: "https://finance.maharashtra.gov.in/Sitemap/finance/pdf/1988_MCS.pdf"
    //         },
    //         {
    //           name: "Pay Commission 1998",
    //           url: "https://finance.maharashtra.gov.in/sitemap/finance/pdf/M_C_S_Rules_1998.pdf"
    //         },
    //         {
    //           name: "Pay Commission 2009",
    //           url: "https://finance.maharashtra.gov.in/Sitemap/finance/pdf/6thpay-notification2009.pdf"
    //         },
    //         {
    //           name: "Pay Commission 2019",
    //           url: "https://finance.maharashtra.gov.in/Sitemap/finance/pdf/7th_Pay_Commission_Notification.pdf"
    //         },
    //         {
    //           name: "Bakshi Samitte Report 1",
    //           url: "https://finance.maharashtra.gov.in/Sitemap/finance/pdf/State_Pay_Committee.pdf"
    //         },
    //       ]
    //     },
        {
          name: "D.A. Rates",
          children: [
             {
              name: "D.A. Rate July 24",
              url: "https://drive.google.com/file/d/1_d6y94hIytncqQC6roGxaNsQ4BKAYOhB/view?usp=sharing/view"
            },
          ]
        },
    //     {
    //       name: "H.R.A. Rates",
    //       children: [
    //         {
    //           name: "H.R.A. Datewise GRs",
    //           url: "https://finance.maharashtra.gov.in/Sitemap/finance/pdf/Sthaput.pdf"
    //         },
    //         // {
    //         //   name: "Sample PDF 2",
    //         //   url: "https://example.com/sample2.pdf"
    //         // }
    //       ]
    //     },
    //     {
    //       name: "T.R.A. Rates",
    //       children: [
    //         {
    //           name: "T.R.A. Datewise GRs",
    //           url: "https://finance.maharashtra.gov.in/Sitemap/finance/pdf/Vahtuk_Bhatta.pdf"
    //         },
    //         // {
    //         //   name: "Sample PDF 2",
    //         //   url: "https://example.com/sample2.pdf"
    //         // }
    //       ]
    //     }
    //   ]
    // },
      {
      name: "Higher Education Department",
      children: [
        // {
        //   name: "Pay Commission",
        //   children: [
        //     {
        //       name: "Sample PDF 1",
        //       url: "https://example.com/sample1.pdf"
        //     },
        //     {
        //       name: "Sample PDF 2",
        //       url: "https://example.com/sample2.pdf"
        //     }
        //   ]
        // },
        {
          name: "Placement and Promotion of Teachers",
          children: [
            {
              name: "CAS Circular 7-7-22",
              url: "https://dte.maharashtra.gov.in/wp-content/uploads/2022/07/cas_circular_7_7_22.pdf"
            },
            // {
            //   name: "Sample PDF 2",
            //   url: "https://example.com/sample2.pdf"
            // }
          ]
        },
        // {
        //   name: "Appointment, Promotion and ACP 1,2 of Non-Teaching Staff",
        //   children: [
        //     {
        //       name: "Sample PDF 1",
        //       url: "https://example.com/sample1.pdf"
        //     },
        //     {
        //       name: "Sample PDF 2",
        //       url: "https://example.com/sample2.pdf"
        //     }
        //   ]
        // },
      ]
    },
    {
      name: "School Education Department",
      children: [
        {
          name: "Pay Commission",
          children: [
            {
              name: "5th Pay Commission",
              url: "https://gr.maharashtra.gov.in/Site/Upload/Government%20Resolutions/Marathi/20090101122446001.pdf"
            },
            {
              name: "6th Pay Commission(Part-Time Teachers)",
              url: "https://gr.maharashtra.gov.in/Site/Upload/Government%20Resolutions/Marathi/20091104165847001.pdf"
            },
            {
              name: "6th Pay Commission(Full-Time Teachers)",
              url: "https://gr.maharashtra.gov.in/Site/Upload/Government%20Resolutions/Marathi/20090612183514001.pdf"
            },
            {
              name: "7th Pay Commission(Part-Time Teachers)",
              url: "https://gr.maharashtra.gov.in/Site/Upload/Government%20Resolutions/Marathi/201908071443071321.pdf"
            },
            {
              name: "7th Pay Commission(Full-Time Teachers)",
              url: "https://gr.maharashtra.gov.in/Site/Upload/Government%20Resolutions/Marathi/201902221248098421.....pdf"
            }
          ]
        },
        // {
        //   name: "Senior and Selection Grade",
        //   children: [
        //     {
        //       name: "Sample PDF 1",
        //       url: "https://example.com/sample1.pdf"
        //     },
        //     {
        //       name: "Sample PDF 2",
        //       url: "https://example.com/sample2.pdf"
        //     }
        //   ]
        // },
        // {
        //   name: "Appointment and Promotion",
        //   children: [
        //     {
        //       name: "Sample PDF 1",
        //       url: "https://example.com/sample1.pdf"
        //     },
        //     {
        //       name: "Sample PDF 2",
        //       url: "https://example.com/sample2.pdf"
        //     }
        //   ]
        // },
        // {
        //   name: "Junior College Teachers",
        //   children: [
        //     {
        //       name: "Sample PDF 1",
        //       url: "https://example.com/sample1.pdf"
        //     },
        //     {
        //       name: "Sample PDF 2",
        //       url: "https://example.com/sample2.pdf"
        //     }
        //   ]
        // },
        // {
        //   name: "Seniority List",
        //   children: [
        //     {
        //       name: "Sample PDF 1",
        //       url: "https://example.com/sample1.pdf"
        //     },
        //     {
        //       name: "Sample PDF 2",
        //       url: "https://example.com/sample2.pdf"
        //     }
        //   ]
        // },
      ]
    },
    {
      name: "Higher Education Department",
      children: [
        // {
        //   name: "Pay Commission",
        //   children: [
        //     {
        //       name: "Sample PDF 1",
        //       url: "https://example.com/sample1.pdf"
        //     },
        //     {
        //       name: "Sample PDF 2",
        //       url: "https://example.com/sample2.pdf"
        //     }
        //   ]
        // },
        {
          name: "Placement and Promotion of Teachers",
          children: [
            {
              name: "CAS Circular 7-7-22",
              url: "https://dte.maharashtra.gov.in/wp-content/uploads/2022/07/cas_circular_7_7_22.pdf"
            },
            // {
            //   name: "Sample PDF 2",
            //   url: "https://example.com/sample2.pdf"
            // }
          ]
        },
        // {
        //   name: "Appointment, Promotion and ACP 1,2 of Non-Teaching Staff",
        //   children: [
        //     {
        //       name: "Sample PDF 1",
        //       url: "https://example.com/sample1.pdf"
        //     },
        //     {
        //       name: "Sample PDF 2",
        //       url: "https://example.com/sample2.pdf"
        //     }
        //   ]
        // },
      ]
    },
    // {
    //   name: "Vocational Department",
    //   children: [
    //         {
    //           name: "Sample PDF 1",
    //           url: "https://example.com/sample1.pdf"
    //         },
    //         {
    //           name: "Sample PDF 2",
    //           url: "https://example.com/sample2.pdf"
    //         }
    //   ]
    // },
  ];

  const [selectedPDF, setSelectedPDF] = useState("");

  // Manage sizing
  const viewerWidth = "100vw"; // 75% of viewport width
  const viewerHeight = "100%"; // Full viewport height

  return (
    <div className="flex h-screen mt-20">
      <Sidebar structure={pdfStructure} onSelectPDF={setSelectedPDF} />
      <PDFViewer fileUrl={selectedPDF} width={viewerWidth} height={viewerHeight} />
    </div>
  );
};

export default GR;